import BaseMapper from './base';
import { Component, CustomHtmlProps } from '../types';
import { cmsHtmlParser } from '../helpers';

class ModuleCustomHtml extends BaseMapper {
  public async generateComponent(): Promise<Component<CustomHtmlProps>> {
    return {
      name: 'CustomHtml',
      props: this.getProps(),
    };
  }

  public getProps(): CustomHtmlProps {
    const { locale } = this.cmsHelper;
    let htmlContent = this.page.content.module_simple_html_body_raw[locale];

    if (this.page.content.module_simple_html_body_type.pop() === '1') {
      htmlContent = this.page.content.module_simple_html_body[locale];
    }

    const { bodyParsed, cssParsed } = cmsHtmlParser({ htmlContent });

    return {
      bodyParsed,
      cssParsed,
      device:
        parseInt(
          this.mapContentField({
            contentKey: 'target_device',
          }),
          10,
        ) || 1,
    };
  }
}

export default ModuleCustomHtml;
